import { PdfViewer } from './detail';

/**
 * Init and load PDFViewer
 */
window.addEventListener('DOMContentLoaded', () => {
    const pdf_viewer = new PdfViewer(window.__VUMEDI_PDF__);
    pdf_viewer.load();
});
